namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiEsperienzeListGridDialog extends Serenity.TemplatedDialog<UtentiProdottiEsperienzeListGridOptions> {

        private checkGrid: UtentiProdottiEsperienzeListGrid;

        constructor(opt: UtentiProdottiEsperienzeListGridOptions) {
            super(opt);

            this.checkGrid = new UtentiProdottiEsperienzeListGrid(this.byId("CheckGrid"), opt);
            this.dialogTitle = "";
        }

        protected getTemplate() {
            return `<div id="~_CheckGrid"></div>`;
        }

    }
}